
import axios from 'axios';
function geocode(address) {
  return axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${process.env.VUE_APP_API_KEY_MAPS}`,
  );
}
export default {
    geocode,
  };